import { Routes, Route } from 'react-router-dom'
import { AuthProvider } from './auth/AuthContext'
import { RequireAuth } from './auth/RequireAuth'
import { AgentTokensPanel } from './components/AgentTokensPanel'
import { AppShell } from './components/AppShell'
import { LoginPage } from './components/LoginPage'
import { PushPermissionBanner } from './components/PushPermissionBanner'
import { BookPage } from './pages/BookPage'
import { FleetPage } from './pages/FleetPage'
import { OpsPage } from './pages/OpsPage'

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/*"
          element={
            <RequireAuth>
              <>
                <PushPermissionBanner />
                <Routes>
                  <Route element={<AppShell />}>
                    <Route path="/" element={<FleetPage />} />
                    <Route path="/book/:id" element={<BookPage />} />
                    <Route path="/ops" element={<OpsPage />} />
                    {/* Catch-all lives inside the AppShell group (not as a
                        bare sibling) so it still receives the ws instance
                        via Outlet context — FleetPage calls
                        useOutletContext() unconditionally and would throw
                        if rendered outside the shell. */}
                    <Route path="*" element={<FleetPage />} />
                  </Route>
                  <Route path="/agent-tokens" element={<AgentTokensPanel />} />
                </Routes>
              </>
            </RequireAuth>
          }
        />
      </Routes>
    </AuthProvider>
  )
}

export default App
